import React, { useEffect } from 'react'
import { AuthProvider } from '@nic/kc-auth'
import { api } from '@nic/nic-api'
import Keycloak, { KeycloakInitOptions } from 'keycloak-js'
import { InnerApp } from './InnerApp'

interface AppI {
  conf: string
  locale?: string
}

const App: React.FC<AppI> = (props) => {
  const [keycloakJson, setKeycloakJson] = React.useState<Keycloak.KeycloakConfig>(
    {} as Keycloak.KeycloakConfig
  )
  const keycloakInitOptions = React.useMemo<KeycloakInitOptions>(
    () => ({
      onLoad: 'login-required',
    }),
    []
  )
  const handleKeycloakInstance = React.useCallback(
    (keycloak: Keycloak) => {
      api(keycloak)
    },
    []
  )

  useEffect(() => {
    fetch(props.conf as string)
      .then((response) => response.json())
      .then((data) => {
        const conf = { realm: data.realm, url: data['auth-server-url'], clientId: data.resource }
        setKeycloakJson(conf)
      })
      .catch((error) => console.error('Error fetching data:', error))
  }, [props.conf])

  // console.log('INSPECTION ->', App.name)
  //evita la doppia chiamata delle componenti sotto
  if (keycloakJson.clientId && keycloakJson.realm && keycloakJson.url) {
    return (
      <AuthProvider
        keycloakConfig={keycloakJson}
        keycloakInitOptions={keycloakInitOptions}
        onKeycloakInstance={handleKeycloakInstance}
      >
        <InnerApp />
      </AuthProvider>
    )
  } else {
    return <>Waiting conf</>
  }
}

export default App
